import createSubscriptionPaymentSaga from './create'
import onePaymentSaga from './oneSaga'

const subscriptionPaymentSagas = [createSubscriptionPaymentSaga(), onePaymentSaga()]

export default subscriptionPaymentSagas
